import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Grid,
  CardHeader,
  Divider,
  Alert,
  AlertTitle,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import { useNavigate, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const UsuarioForm = ({
  title,
  subtitle,
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  setFieldValue,
  isLoading,
  hasError,
  hasSuccess,
  fgConsultar,
  ...rest
}) => {
  const history = useNavigate();

  if (!values) {
    return null;
  }

  return (
    <form onSubmit={handleSubmit} method="post">
      <Helmet>
        <title>{`${title} | Sistema de Afiliados`}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="lg">
          <Card>
            <CardHeader
              subheader={subtitle}
              title={title}
              avatar={
                <IconButton size="small" color="primary" onClick={() => history(-1)}>
                  <ArrowBackIcon />
                </IconButton>
              }
              action={
                fgConsultar ? (
                  <Link to={`/app/usuario/${values.id}/edit`}>
                    <IconButton size="small">
                      <EditIcon />
                    </IconButton>
                  </Link>
                ) : null
              }
            />

            <Divider />

            {(hasError || (errors && errors.length > 0)) && (
              <CardContent sx={{ p: 0 }}>
                <Alert severity="error">
                  <AlertTitle>Atenção</AlertTitle>
                  {hasError}
                  {Object.values(errors)}
                </Alert>
              </CardContent>
            )}

            {hasSuccess && (
              <CardContent sx={{ p: 0 }}>
                <Alert severity="success">
                  <AlertTitle>Sucesso</AlertTitle>
                  {hasSuccess}
                </Alert>
              </CardContent>
            )}

            <CardContent>
              <Grid container spacing={3} wrap="wrap">
                {values.id && Number(values.id) > Number(0) ? (
                  <Grid item md={3} sm={3} xs={12}>
                    <TextField
                      fullWidth
                      label="ID"
                      name="id"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      value={values.id}
                      disabled
                      readOnly
                    />
                  </Grid>
                ) : null}

                <Grid item md={12} sm={12} xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="Nome"
                    name="name"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={isLoading || isSubmitting || fgConsultar}
                    error={Boolean(touched.name && errors.name)}
                    helperText={touched.name && errors.name}
                  />
                </Grid>

                <Grid item md={12} sm={12} xs={12}>
                  <TextField
                    fullWidth
                    required
                    label="E-mail"
                    name="email"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    type="email"
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={isLoading || isSubmitting || fgConsultar}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <TextField
                    fullWidth
                    label="Celular"
                    name="phone"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    placeholder="(00) 00000-0000"
                    value={values.phone || ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={isLoading || isSubmitting || fgConsultar}
                    error={Boolean(touched.phone && errors.phone)}
                    helperText={touched.phone && errors.phone}
                  />
                </Grid>

                <Grid item md={6} sm={6} xs={12}>
                  <TextField
                    fullWidth
                    label="CPF"
                    name="cpf"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    placeholder="000.000.000-00"
                    value={values.cpf || ''}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    disabled={isLoading || isSubmitting || fgConsultar}
                    error={Boolean(touched.cpf && errors.cpf)}
                    helperText={touched.cpf && errors.cpf}
                  />
                </Grid>

                {!fgConsultar && (
                  <Grid item md={12} sm={12} xs={12}>
                    <TextField
                      fullWidth
                      required={!values.id}
                      label="Senha"
                      name="password"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      type="password"
                      value={values.password}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      disabled={isLoading || isSubmitting}
                      error={Boolean(touched.password && errors.password)}
                      helperText={
                        (touched.password && errors.password) ||
                        (values.id ? 'Deixe em branco para manter a senha atual' : '')
                      }
                    />
                  </Grid>
                )}

                <Grid item md={12} sm={12} xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={values.is_admin || false}
                        onChange={(e) => setFieldValue('is_admin', e.target.checked)}
                        name="is_admin"
                        color="primary"
                        disabled={isLoading || isSubmitting || fgConsultar}
                      />
                    }
                    label="Administrador"
                  />
                  <FormHelperText>
                    Usuários administradores têm acesso total ao sistema
                  </FormHelperText>
                </Grid>
              </Grid>
            </CardContent>

            {!fgConsultar && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2
                }}
              >
                <Button
                  color="primary"
                  disabled={isLoading || isSubmitting}
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {isLoading || isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
              </Box>
            )}
          </Card>
        </Container>
      </Box>
    </form>
  );
};

UsuarioForm.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  errors: PropTypes.object,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  touched: PropTypes.object,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  hasError: PropTypes.string,
  hasSuccess: PropTypes.string,
  fgConsultar: PropTypes.bool
};

UsuarioForm.defaultProps = {
  subtitle: '',
  errors: {},
  touched: {},
  isLoading: false,
  hasError: null,
  hasSuccess: null,
  fgConsultar: false
};

export default UsuarioForm;
